import React, { useEffect } from 'react';
import Phaser from 'phaser';
import { getRandomPosition } from '../functions';
import AttractorTimeout from '../../warning/attractorTimeout';

const PhaserGame = ({ config, selectBall, levelNumber, passRefUpward, fullConfig }) => {

    AttractorTimeout(fullConfig, passRefUpward);

    const containerWidth = 1920;
    const containerHeight = 935;

    useEffect(() => {

        const gameConfig = {
            type: Phaser.AUTO,
            width: containerWidth,
            height: containerHeight,
            parent: 'phaser-canvas',
            physics: {
                default: 'arcade',
                arcade: {
                    debug: false
                }
            },
            scene: {
                preload: preload,
                create: create
            },
            render: {
                transparent: true
            }
        };
        const game = new Phaser.Game(gameConfig);

        return () => {
            game.destroy(true);
        }
    // eslint-disable-next-line
    }, [])

    function preload () {
        this.load.image('ball-red', 'img/game_icons/track-the-ball/ball-red.svg');
        this.load.image('ball-grey', 'img/game_icons/track-the-ball/ball-grey.svg');
        this.load.image('ball-correct', 'img/game_icons/track-the-ball/ball-correct.svg');
        this.load.image('ball-incorrect', 'img/game_icons/track-the-ball/ball-incorrect.svg');
        this.load.image('timer-background', 'img/game_icons/track-the-ball/timer-background.svg');
    }

    function create() {
        const scene = this;

        const timerCircle = scene.physics.add.image(960, 940, 'timer-background');
        timerCircle.setSize(190, 160);
        timerCircle.body.setImmovable(true);
        timerCircle.setScale(0);

        const phaserCanvas = document.getElementById('phaser-canvas');

        const balls = scene.add.group();

        loadBalls(scene, balls, timerCircle);

        scene.tweens.add({
            targets     : balls.children.entries,
            scale       : 1,
            ease        : 'Linear',
            duration    : 300,
        });

        phaserCanvas.addEventListener('startGame',  () => {

            balls.children.entries.forEach(ball => {
                ball.setVelocity(Phaser.Math.Between(200, 300), Phaser.Math.Between(200, 300));
            })
            scene.tweens.add({
                targets     : timerCircle,
                scale       : 1,
                ease        : 'Linear',
                duration    : 300,
            });
        })

        phaserCanvas.addEventListener('turnGrey',  () => {
            balls.getChildren().forEach(ball => {
                ball.setTexture('ball-grey');
            })
        });

        phaserCanvas.addEventListener('timerEnd', () => {

            balls.getChildren().forEach(ball => {
                ball.setVelocity(0, 0);

                ball.on('pointerdown', () => {
                    ball.disableInteractive();

                    if (ball.getData('colour') === 'red') {
                        ball.setTexture('ball-correct');
                        addScoreText(scene, ball, 'correct');
                        selectBall(true)
                    } else {
                        ball.setTexture('ball-incorrect');
                        addScoreText(scene, ball, 'incorrect');
                        selectBall(false)
                    }
                })
            })
        });

        phaserCanvas.addEventListener('levelComplete', () => {

            if (balls.children) {
                balls.getChildren().forEach(ball => {
                    ball.disableInteractive();
                });
            }

            scene.tweens.add({
                targets     : timerCircle,
                scale       : 0,
                ease        : 'Linear',
                duration    : 300,
            });
        })

        phaserCanvas.addEventListener('gameOver', () => {

            if (balls.children) {
                balls.getChildren().forEach(ball => {
                    ball.disableInteractive();
                });
            }

            scene.tweens.add({
                targets     : timerCircle,
                scale       : 0,
                ease        : 'Linear',
                duration    : 300,
            });
        })

        phaserCanvas.addEventListener('nextLevel', () => {

            balls.clear(true, true);

            scene.tweens.add({
                targets     : timerCircle,
                scale       : 1,
                ease        : 'Linear',
                duration    : 300,
            });
        })
    }

    function addScoreText(scene, ball, scoreType) {
        let points = '';
        if (scoreType === 'correct') {
            points = `+${config.ball_correct_points * levelNumber}`;
        } else if (scoreType === 'incorrect') {
            points = `${config.ball_incorrect_points * levelNumber}`;
        }
        const scoreIncreaseText = scene.add.text(ball.x + 50, ball.y - 50, points, {
            fontFamily: 'Kiro',
            fontSize: '34px',
            letterSpacing: '3.7px'
        });
        scoreIncreaseText.setAlpha(0);
        scene.tweens.add({
            targets: scoreIncreaseText,
            alpha: 1,
            ease: 'Linear',
            duration: 300,
        });
        setTimeout(() => {
            scene.tweens.add({
                targets: scoreIncreaseText,
                alpha: 0,
                ease: 'Linear',
                duration: 300,
            });
        }, 1000);
    }

    function loadBalls (scene, ballGroup, timerCircle) {

        const ballsToLoad = [];
        const redBalls = config.starting_red_balls + (config.level_increment_red_balls * (levelNumber - 1));
        const greyBalls = config.starting_grey_balls + (config.level_increment_grey_balls * (levelNumber - 1));

        for (let i = 0; i < redBalls; i++) {
            ballsToLoad.push('red');
        }
        for (let i = 0; i < greyBalls; i++) {
            ballsToLoad.push('grey');
        }

        ballsToLoad.forEach(ballColour => {
            const position = getRandomPosition(containerWidth, containerHeight, 100, 100);
            const ball = scene.physics.add.image(position.x, position.y, `ball-${ballColour}`);
            // ball.body.setCircle(50)
            ball.setBounce(1);
            ball.setCollideWorldBounds(true);
            ball.setInteractive();
            ball.setData({colour: ballColour})
            ball.setSize(90, 90);
            ball.setScale(0);
            ballGroup.add(ball);
            scene.physics.add.collider(ball, timerCircle);
        });

        scene.physics.add.collider(ballGroup);
    }

    return (
        <div id="phaser-canvas" className="phaser-canvas" ></div>
    );
};

export default PhaserGame;